module.exports = __webpack_public_path__ + "img/automated-rules-color.0e11fb4f.svg";